import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-auditor-orders',
  templateUrl: './auditor-orders.component.html',
  styleUrls: ['./auditor-orders.component.scss']
})
export class AuditorOrdersComponent implements OnInit {

  role: any = localStorage.getItem('role');
  managerId = localStorage.getItem('managerId');
  stores: any[] = [];
  loading: boolean = false;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    if (this.role !== 'receipt_auditor' || !this.managerId) {
      this.toastr.error('Access denied.');
      this.router.navigate(['/dashboard']);
      return;
    }

    this.loadStores();
  }

  loadStores(): void {
    this.loading = true;
    this.spinner.show();

    this.apiService.getRequest(`${ApiUrl.storeListById}${this.managerId}`)
      .subscribe(
        (res: any) => {
          this.loading = false;
          this.spinner.hide();

          if (res && res.response && res.response.data) {
            this.stores = res.response.data;

            if (this.stores.length === 1) {
              this.openOrders(this.stores[0]._id);
              return;
            }
          } else {
            this.toastr.error('No stores found for this account');
            this.stores = [];
          }
        },
        (error: any) => {
          this.loading = false;
          this.spinner.hide();
          this.toastr.error('Failed to load stores');
        }
      );
  }

  openOrders(storeId: string): void {
    this.router.navigate(['/store', storeId, 'ecommerce'], { queryParams: { tab: 'orders' } });
  }

  getStoreStatusText(store: any): string {
    return store.status === 1 ? 'Active' : 'Inactive';
  }

  getStoreStatusClass(store: any): string {
    return store.status === 1 ? 'text-success' : 'text-danger';
  }
}
